import { Color } from '@nect/ui/theme/color';
import React, { forwardRef } from 'react';

import { BorderRadius, Elevation, ShadowColor, SpacingProp } from '../../theme';
import BoxStyled from './box.styled';

export type BoxDirection =
    | 'row'
    | 'column'
    | 'row-responsive'
    | 'row-reverse'
    | 'column-reverse';

export type BoxAlignItems = 'start' | 'center' | 'end' | 'baseline' | 'stretch';

// @TODO Implement this
type BoxAlignContent =
    | 'start'
    | 'center'
    | 'end'
    | 'between'
    | 'around'
    | 'stretch';
type BoxAlignSelf = 'start' | 'center' | 'end' | 'stretch';
export interface IBoxProps {
    /**
    Border Radius
    */
    radius?: BorderRadius;

    /**
    Margin
    */
    margin?: SpacingProp;

    /**
    Padding
    */
    padding?: SpacingProp;

    /**
     Background Color
     */
    backgroundColor?: Color;

    /**
     Border Size
     */
    borderSize?: number;

    /**
     Border Color
     */
    borderColor?: Color;

    /**
    Elevation level to cast shadows
     */
    elevation?: Elevation;

    /**
    Shadow color
     */
    shadowColor?: ShadowColor;

    /**
    Flex direction wrapper
     */
    direction?: BoxDirection;

    /**
    Flex align-items wrapper
     */
    align?: BoxAlignItems;

    /**
    Content
    */
    children?: React.ReactNode;

    /**
     Inline CSS style
     */
    style?: React.CSSProperties;

    /**
    To act as diff HTML tag such as: div, header, nav, button, a, ul, li...
     */
    as?: any;
    forwardedAs?: any;
    // @TODO Do proper type
    //  Pick<typeof BoxStyled.BoxStyled, 'as'>;

    /**
     Class Name mainly use to extend with styled component
     */
    className?: string;

    /**
     Element id
     */
    id?: string;

    /**
     Element role
     */
    role?: string;

    /**
     onKeydown event handler
     */
    onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;

    /**
     onFocus event handler
     */
    onFocus?: React.FocusEventHandler<HTMLDivElement>;

    /**
     onFocus event handler
     */
    onBlur?: React.FocusEventHandler<HTMLDivElement>;
}

export const Box = forwardRef(
    (
        {
            radius = 'None',
            borderColor = Color.grey400,
            borderSize = 0,
            backgroundColor,
            margin,
            padding,
            elevation,
            shadowColor = 'light',
            children,
            className,
            direction = 'column',
            style,
            align,
            id,
            role,
            forwardedAs,
            ...props
        }: IBoxProps,
        ref,
    ) => {
        return (
            <BoxStyled.BoxStyled
                className={className}
                $radius={radius}
                $borderSize={borderSize}
                $borderColor={borderColor}
                $backgroundColor={backgroundColor}
                $margin={margin}
                $padding={padding}
                $elevation={elevation}
                $shadowColor={shadowColor}
                $direction={direction}
                $align={align}
                style={style}
                ref={ref as any}
                id={id}
                forwardedAs={forwardedAs}
                role={role}
                {...{ ...props, align: undefined }}
            >
                {children}
            </BoxStyled.BoxStyled>
        );
    },
);

Box.displayName = 'Box';
